import React, { useEffect, useState } from "react";
import { Prompt } from "react-router-dom";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from 'react-redux'
import Images from "../../../shared/images";
import Errors from "./../../../shared/errors";
import {
  renderCurrencyField,
  renderSelectField,
  renderSingleReactSelect,
  renderTextAreaField,
  renderTextField,
  renderUrlField,
  renderHiddenInput
} from "./../../../shared/form-helpers";
import required, { maxDecimalValue } from "../../../shared/validation";
import FormErrors from "../../../shared/form-errors";

let SetDressingForm = (props) => {
  const {
    handleSubmit,
    handleDelete,
    onChangeSetDressingToProp,
    pristine,
    reset,
    submitting,
    errors,
    acquisitionMethodEnum,
    mode,
    acquisitionMethodValue,
    submitFailed,
    invalid,
    allSceneSettings,
    filmId,
    onCloseForm,
    fetchUrlPreview,
    loadingUrlPreview
  } = props;

  const thisSetDressing = props.initialValues || {};
  const readOnly = thisSetDressing.readOnly || loadingUrlPreview;

  const [editUrl, setEditUrl] = useState(false);
  const [prevLoadingPreview, setPrevLoadingPreview] = useState<boolean>(false);

  const onSetEditUrl = (state, url) => {
    if (!state && url) {
      fetchUrlPreview(url);
    }

    setEditUrl(state);
  }

  // When URL preview finishes loading, force form to be dirty so Save enables
  useEffect(() => {
    if (prevLoadingPreview && !loadingUrlPreview) {
      if (props.change) {
        props.change("__urlPreviewAppliedAt", Date.now());
      }
    }
    setPrevLoadingPreview(!!loadingUrlPreview);
  }, [loadingUrlPreview]);

  const acquisitionMethodOptions = (acquisitionMethodEnum || []).map((item) => { return { value: item.value, label: item.name } });

  const sceneSettingOptions = (allSceneSettings || []).map((item) => { return { value: item.id, label: item.name } });

  return (
    <>
      <Prompt when={!pristine} message="" />
      {mode === "add" && <h2 className="menu-label">Add Set Dressing</h2>}
      {mode === "edit" && <h2 className="menu-label">Edit Set Dressing</h2>}
      <div className="columns">
        <div className="column">
          {errors && <Errors errors={errors} />}
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Field
              name="name"
              label="Name"
              component={renderTextField}
              validate={[required]}
              required
              readOnly={readOnly}
            />

            <Field
              name="sceneSettingId"
              label="Scene Setting"
              component={renderSingleReactSelect}
              options={sceneSettingOptions}
              validate={[required]}
              required
              readOnly={readOnly}>
            </Field>

            <Field
              name="link"
              label="Link"
              type="url"
              component={renderUrlField}
              readOnly={readOnly}
              setEditUrl={onSetEditUrl}
              editUrl={editUrl}
            />

            {/* Hidden field used to flip pristine to dirty after URL preview updates fields/images */}
            <Field name="__urlPreviewAppliedAt" component={renderHiddenInput} readOnly={true} />

            <Field
              name="description"
              label="Description"
              component={renderTextAreaField}
              readOnly={readOnly}></Field>

            <Field
              name="acquisitionMethod"
              label="Acquisition Method"
              component={renderSingleReactSelect}
              options={acquisitionMethodOptions}
              validate={[required]}
              required
              readOnly={readOnly}>
            </Field>

            {acquisitionMethodValue != 3 && acquisitionMethodValue != 4 && acquisitionMethodValue != 5 &&
              <Field
                name="buyBudget"
                label="Budget"
                component={renderCurrencyField}
                validate={[maxDecimalValue]}
                readOnly={readOnly}></Field>
            }
            {acquisitionMethodValue == 3 &&
              <Field
                name="dailyHireBudget"
                label="Daily Budget"
                component={renderCurrencyField}
                validate={[maxDecimalValue]}
                readOnly={readOnly}></Field>
            }
            <div className="field-body">
              <Field
                name="quantity"
                type="number"
                label="Quantity Required"
                component={renderTextField}
                parse={(value) => Number(value)}
                validate={[required, maxDecimalValue]}
                required
                readOnly={readOnly}
              />
              {acquisitionMethodValue != 4 && acquisitionMethodValue != 5 &&
                <Field
                  name="quantityAcquired"
                  type="number"
                  label="Quantity Acquired"
                  parse={(value) => Number(value)}
                  component={renderTextField}
                  validate={[maxDecimalValue]}
                  readOnly={readOnly}
                />
              }
            </div>

            {!readOnly && <div className="buttons mt-2 sticky-buttons">
              <button
                type="submit"
                className="button is-primary"
                disabled={(pristine || submitting) && !thisSetDressing.enableSave}>
                Save
              </button>
              {onCloseForm && <button type="button" className="button" onClick={onCloseForm}>
                Close
              </button>}
              {mode === "edit" && (
                <>
                  <button
                    type="button"
                    className="button is-text"
                    disabled={submitting || !props.initialValues}
                    onClick={() => handleDelete(thisSetDressing)}>
                    Delete Set Dressing
                  </button>

                  <button type="button"
                    className="button is-text"
                    disabled={submitting || !props.initialValues}
                    onClick={() => onChangeSetDressingToProp(thisSetDressing)}>Change to Prop</button>
                </>
              )}
            </div>}
            <FormErrors submitFailed={submitFailed} invalid={invalid} />
          </form>
        </div>
        <div className="column">
          <Images change={props.change} initialValues={props.initialValues} readOnly={readOnly} filmId={filmId} />
        </div>
      </div>
    </>
  );
}

SetDressingForm = reduxForm({
  form: "editSetDressingForm",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(SetDressingForm);

// Decorate with connect to read form values
const selector = formValueSelector('editSetDressingForm'); // <-- same as form name
const SetDressingFormConnect = connect(
  state => {
    // can select values individually
    const acquisitionMethodValue = selector(state, 'acquisitionMethod')

    return {
      acquisitionMethodValue
    }
  }
)(SetDressingForm)

export default SetDressingFormConnect
